var map = {
	"./anm-card.png": 961,
	"./arrow.png": 962,
	"./arrow.webp": 963,
	"./asset-1.svg": 964,
	"./bg-exclusive.webp": 965,
	"./brand-logo.png": 94,
	"./brand-logo.webp": 966,
	"./btn-black-m.webp": 967,
	"./btn-blue-m-v2.png": 968,
	"./btn-blue-m.png": 969,
	"./btn-blue-m.webp": 970,
	"./btn-white-m-v2.png": 971,
	"./btn-white-m.png": 972,
	"./deposit.webp": 973,
	"./drop-more-btn.webp": 974,
	"./eeziepay.svg": 975,
	"./fcl.svg": 976,
	"./fcl.webp": 977,
	"./fpx-logo.svg": 978,
	"./game-blue.png": 979,
	"./game-img.png": 980,
	"./game-white.png": 981,
	"./global-language.svg": 982,
	"./ifm-logo.svg": 983,
	"./ifm-logo.webp": 984,
	"./modal-bg.jpg": 985,
	"./number-bg.webp": 986,
	"./pagcor.svg": 987,
	"./pagcor.webp": 988,
	"./pool-bg.webp": 989,
	"./promo-given.webp": 990,
	"./side-bar-bg.png": 991,
	"./tether.svg": 992,
	"./title-asset.svg": 993,
	"./winner.webp": 994,
	"./withdrawal.webp": 995,
	"./x33-logo-christmas.png": 996,
	"./x33-logo-cny.png": 997,
	"./x33-logo-halloween.png": 998,
	"./x33-logo-merdeka.png": 999,
	"./x33-logo-mooncake.png": 1000,
	"./x33-logo-raya.png": 1001,
	"./x33-logo-wc.png": 1002,
	"./x33-logo.png": 1003
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 163;